export default "__VITE_ASSET__WQ1bwDMC__"